<template>
    <div>
        <div class="company">
            <img src="@/assets/images/company-banner.png" alt="">
        </div>
        <div class="crumbs">
            <div class="crumbs-content">
                主页 > 公司动态 > 行业方案 > <span style="color:#0075EA;">{{news.title}}</span>
            </div>
            
        </div>

        <div class="news">
            <div class="news-conten">
                <div class="news-left">
                    <div class="left-lists">
                        <div class="left-lists-title">
                            {{news.title}}
                        </div>
                        <div class="left-lists-time">
                            {{news.create_time}}
                        </div>
                        <div class="left-lists-content" v-html="news.content">
                        </div>  
                    </div>
                </div>
                <div class="news-right">
                    <!-- <div>
                        <div class="news-right-title">
                            行业推荐
                        </div>
                        <div class="news-right-lists">
                            <div class="news-right-item">
                                <a href="#">1、动态|撼动酒业成立</a>
                            </div>
                            <div class="news-right-item">
                                <a href=""> 2、应用宝开发者账号申请步骤</a>
                            </div>
                             <div class="news-right-item">
                                <a href=""> 3、开发一个APP有多难？</a>
                            </div>
                            <div class="news-right-item">
                                <a href="">4、运营|如何寻找靠谱的app开发公司</a>
                            </div>
                             <div class="news-right-item">
                                <a href="">5、动态|如何设计一个好的测试用例</a>
                            </div>
                               <div class="news-right-item">
                                <a href="">6、北京app开发公司</a>
                            </div>
                               <div class="news-right-item">                                          
                                <a href="">7、区区一个打卡签到，也有这么多套路</a>
                            </div>
                               <div class="news-right-item">
                                <a href="">8、新闻|社交、直播app上线了</a>
                            </div>
                               <div class="news-right-item">
                                <a href="">9、北京手机app软件开发**名_个性APP开发</a>
                            </div>
                               <div class="news-right-item">
                                <a href="">10、企业大数据分析大数据可视化</a>
                            </div>
                        </div>
                    </div> -->

                    <div>
                        <div class="news-right-title">
                            动态推荐
                        </div>
                        <div class="news-right-lists">
                            <div  v-for="(item,index) in limitNew" :key="index" class="news-right-item">
                                <a :href="'/detail?id=' + item.id"  >{{index + 1}}、{{item.title}}</a>
                            </div>
                        </div>
                    </div>

                    <!-- <div>
                        <div class="news-right-title">
                            最新岗位
                        </div>
                        <div class="news-right-lists">
                            <div class="news-right-item">
                                <a href="#">1、招聘|APP前端开发工程师</a>
                            </div>
                            <div class="news-right-item">
                                <a href="">2、招聘|文案策划|软件开发公司</a>
                            </div>
                             <div class="news-right-item">
                                <a href="">3、招聘|APP前端开发工程师</a>
                            </div>
                            <div class="news-right-item">
                                <a href="">4、招聘|文案策划|软件开发公司</a>
                            </div>
                             <div class="news-right-item">
                                <a href="">5、区区一个打卡签到，也有这么多套路</a>
                            </div>
                        </div>
                    </div> -->
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import {getNewDetail,limitData} from '@/api/index/index'
import router from '@/router'
 export default {
    data(){
        return {
            id :  this.$route.query.id,
            news : {},
            limitNew : []
        }
    },
    created() {
        this.getNew()
        this.getLimitNew()
    },
    methods : {
        getNew() {
            getNewDetail({id:this.id}).then(res => {
                this.news = res.data
            })
        },
        getLimitNew(){
            limitData({limit : 10}).then(res => {
                this.limitNew = res.data
            })
        },
        toDetail(id) {
            router.push({path : '/detail', query : {id : id}})
        }
    }
 }
</script>
<style scoped>
.news{
   width: 100%; 
}
.news-conten{
    width: 1380px;
    margin:  0 auto;
    display: flex;
}
.news-left{
    width: 935px;
}
.news-title {
    width: 100%;
    height: 82px;
    border-bottom: 1px solid #D9D9D9;
    display: flex;
}
.crumbs{
    width: 100%;
    height: 40px;
    line-height: 40px;
    font-size: 14px;
    background-color: #F5F8FA;
    overflow: hidden;
}
.crumbs-content{
    width: 1380px;
    margin: 0 auto;
    text-align: left;
}
.left-lists{
    text-align: left;
}
.left-lists-title{
    margin-top: 34px;
    font-size: 24px;
    font-weight: 500;
}

.left-lists-time{
    margin-top: 14px;
    margin-bottom: 28px;
    color: #888888;
    font-size: 14px;
}


.list-item-right{
    width: 100%;
    margin-left: 17px;
    text-align: left;
}
.list-item-right-top{
    color: #333333;
    font-size: 24px;
    font-weight: 400;
}
.list-item-right-center{
    width: 650px;
    color: #888888;
    font-size: 16px;
    margin-top:14px;
    margin-bottom:14px;
}
.list-item-right-bottom{
    display: flex;
    justify-content: space-between;
}
.bottom-lll-num{
    position: relative;
}
.bottom-lll-img {
    width: 20px;
    height: 20px;
    position:absolute;
    left: -20px;
    top:0;
}
.bottom-lll-img img {
    width:20px;
}
.news-right-title{
    font-size: 18px;
    height: 78px;
    font-weight: 500;
    color: #000000;
    margin-left: 68px;
    line-height: 82px;
    border-bottom: 4px solid #0075EA;
}
.news-right-item{
    color: #555555;

}
.news-right-item a {
    color: #555555;
}
.news-right-item a:hover {
    color: #0075EA;
}
.news-right-lists{
    text-align: left;
    margin-left: 68px;
    margin-top: 17px;
    line-height: 26px;
}
.left-lists-content{
    overflow: hidden;
}
::v-deep .left-lists-content img {
    width: 100%;
}

</style>
